// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border {
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25) !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
}

.text-toolbar {
  padding-left: 4px;
}

/* Delete actions: keep the normal look, turn red with a light red tint on hover */
.item-danger {
  --background-hover: var(--ion-color-danger);
  --background-hover-opacity: 0.1;
}
.item-danger:hover {
  --color: var(--ion-color-danger);
}
.item-danger:hover ion-icon {
  --ion-color-base: var(--ion-color-danger) !important;
  color: var(--ion-color-danger) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popover-anagraph-actions/popover-anagraph-actions.component.scss"],"names":[],"mappings":"AAAA;EACE,2EAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AACA,kFAAA;AACA;EACE,2CAAA;EACA,+BAAA;AAEF;AAAE;EACE,gCAAA;AAEJ;AAAI;EACE,oDAAA;EACA,yCAAA;AAEN","sourcesContent":[".border {\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25) !important;\n  border-top: 0 !important;\n  border-left: 0 !important;\n  border-right: 0 !important;\n}\n.text-toolbar {\n  padding-left: 4px;\n}\n\n/* Delete actions: keep the normal look, turn red with a light red tint on hover */\n.item-danger {\n  --background-hover: var(--ion-color-danger);\n  --background-hover-opacity: 0.1;\n\n  &:hover {\n    --color: var(--ion-color-danger);\n\n    ion-icon {\n      --ion-color-base: var(--ion-color-danger) !important;\n      color: var(--ion-color-danger) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
